import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { Fade } from "react-reveal";
import "./Processes.css";
import ProcessesCard from "../../components/processesCard/ProcessesCard";
import { t } from "i18next";

function Processes(props) {
  const theme = props.theme;
  const certifications = {
    certifications: [
      {
        title: t("sections.processes.titles.1"),
        subtitle: t("sections.processes.content.1"),
        logo_path: "procesos1.jpg",
        certificate_link: "#",
        alt_name: "PrimusLabs",
        color_code: "#5fe6d0",
      },
      {
        title: t("sections.processes.titles.2"),
        subtitle: t("sections.processes.content.2"),
        logo_path: "procesos2.jpg",
        certificate_link: "#",
        alt_name: "PrimusLabs",
        color_code: "#d8f3c6",
      },
      {
        title: t("sections.processes.titles.3"),
        subtitle: t("sections.processes.content.3"),
        logo_path: "procesos3.jpg",
        certificate_link: "#",
        alt_name: "PrimusLabs",
        color_code: "#f4f4e0",
      },
      {
        title: t("sections.processes.titles.4"),
        subtitle: t("sections.processes.content.4"),
        logo_path: "procesos4.jpg",
        certificate_link: "#",
        alt_name: "PrimusLabs",
        color_code: "#cdd7ef",
      },
      {
        title: t("sections.processes.titles.5"),
        subtitle: t("sections.processes.content.5"),
        logo_path: "procesos5.jpg",
        certificate_link: "#",
        alt_name: "PrimusLabs",
        color_code: "#8BCDFF",
      },
      {
        title: t("sections.processes.titles.6"),
        subtitle: t("sections.processes.content.6"),
        logo_path: "procesos6.jpg",
        certificate_link: "#",
        alt_name: "PrimusLabs",
        color_code: "#B9D9CF",
      },
      {
        title: t("sections.processes.titles.7"),
        subtitle: t("sections.processes.content.7"),
        logo_path: "procesos7.jpg",
        certificate_link: "#",
        alt_name: "PrimusLabs",
        color_code: "#D16D81",
      },
      {
        title: t("sections.processes.titles.8"),
        subtitle: t("sections.processes.content.8"),
        logo_path: "procesos8.jpg",
        certificate_link: "#",
        alt_name: "PrimusLabs",
        color_code: "#B14F70",
      },
      {
        title: t("sections.processes.titles.9"),
        subtitle: t("sections.processes.content.9"),
        logo_path: "procesos9.jpg",
        certificate_link: "#",
        alt_name: "PrimusLabs",
        color_code: "#46388A",
      },
      {
        title: t("sections.processes.titles.10"),
        subtitle: t("sections.processes.content.10"),
        logo_path: "procesos10.jpg",
        certificate_link: "#",
        alt_name: "PrimusLabs",
        color_code: "#4352AB",
      },
      {
        title: t("sections.processes.titles.0"),
        subtitle: t("sections.processes.content.0"),
        logo_path: "procesos0.jpg",
        certificate_link: "#",
        alt_name: "PrimusLabs",
        color_code: "#56ACC3",
      },
      {
        title: t("sections.processes.titles.11"),
        subtitle: t("sections.processes.content.11"),
        logo_path: "procesos11.jpg",
        certificate_link: "#",
        alt_name: "PrimusLabs",
        color_code: "#cce1f2",
      },
      {
        title: t("sections.processes.titles.12"),
        subtitle: t("sections.processes.content.12"),
        logo_path: "procesos12.jpg",
        certificate_link: "#",
        alt_name: "PrimusLabs",
        color_code: "#c6f8e5",
      },
    ],
  };
  return (
    <div className="privacy-main">
      <Header theme={theme} setTheme={props.setTheme} />
      <div className="basic-projects">
        <Fade bottom duration={2000} distance="40px">
          <div className="privacy-heading-div">
            <div className="privacy-heading-text-div">
              <h1
                className="privacy-heading-text"
                style={{ color: theme.text }}
              >
                {t("titles.PROCESSES")}
              </h1>
            </div>
          </div>
        </Fade>

        <div className="main" id="certs">
          <div className="certs-body-div">
            {certifications.certifications.map((cert, index) => {
              return <ProcessesCard certificate={cert} theme={theme} key={index} />;
            })}
          </div>
        </div>
      </div>
      <Footer theme={props.theme} onToggle={props.onToggle} />
    </div>
  );
}

export default Processes;
